import React, { useEffect } from 'react';
import dynamic from 'next/dynamic';

const CompanyBlogPost = dynamic(() =>
  import('@/pages/company/components/company-blog-post-page'),
);
import { CompanyBlogPostPageProps } from '@/pages/company/components/company-blog-post-page/types';
import {
  getStaticPaths,
  getStaticProps,
} from '@/pages/company/utils/blog-page';
import useAnalyticsWithSource from '@/hooks/use-analytics-with-source';
import { useRouter } from 'next/router';

const CompanyBlogPostIndexPage = (props: CompanyBlogPostPageProps) => {
  const { query, pathname } = useRouter();
  const { trackPageView } = useAnalyticsWithSource();

  useEffect(() => {
    trackPageView(pathname, {
      query: query,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return <CompanyBlogPost {...props} />;
};

export { getStaticPaths, getStaticProps };
export default CompanyBlogPostIndexPage;
